module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/hero_tablet-5c1012e2250b8f54438ad253db44e2d2.jpg";